export default () => ({
  handler: 'relativeUrl',
  data: ({
    gameId, queryString,
  }) => (
    `/casino/games/${gameId}/launch${queryString ? `?${queryString}` : ''}`
  ),
});
